import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import RouterService from '@ember/routing/router-service';
import SetupGuideController from 'cio/pods/setup-guide/controller';
import SetupGuide from 'cio/models/setup-guide';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { ApiResponse, ApiError } from 'cio/services/api';
import DS from 'ember-data';

export default class SetupGuideRoute extends Route {
  @service account!: AccountService;
  @service router!: RouterService;
  @service store!: DS.Store;

  crumb() {
    return {
      name: 'Setup Guide',
      path: 'setup-guide',
    };
  }

  model() {
    return this.store.findRecord('setup-guide', 'current');
  }

  afterModel(model: SetupGuide) {
    if (!model.firstMessageId) {
      return;
    }

    // If there is a campaign or a newsletter created via this setup guide, ensure it loads
    // before we transition into the setup guide. If we don't do this,
    // "setupGuide.firstMessage" will return empty because related
    // campaign/newsletter are not loaded into the store.
    return model.loadFirstMessage()?.catch((e: ApiResponse) => {
      // 404 response means that campaign/newsletter created via this setup guide was deleted
      // clear it from the setup guide to avoid invalid, stuck setup guide state
      if (!isEmpty(e.errors) && (e.errors as ApiError[])[0].status === '404') {
        return model.clearFirstMessage();
      }

      throw e;
    });
  }

  redirect(model: SetupGuide) {
    if (model.completedAt) {
      return this.router.transitionTo('dashboard');
    }

    return;
  }

  @action
  willTransition(transition: any) {
    this.setLastActiveSetupGuideStep(transition);
  }

  private setLastActiveSetupGuideStep(transition: any) {
    let controller = this.controllerFor(this.routeName) as SetupGuideController;
    if (!controller) {
      throw new Error('controller not instantiated for setup-guide');
    }

    if (transition.to?.name.startsWith('setup-guide')) {
      controller.set('lastActiveSetupUpGuideStep', transition.to.name);
    }
  }
}
